<div class="details-container" [ngClass]="{ 'missing-content': !deviceModel() }">
  <mat-icon [svgIcon]="IconNames.ice_phone" />
  <span>
    <div class="detail-row">
      <span>Modell:</span>
      <span>{{ deviceModel() }}</span>
    </div>
    <div class="detail-row">
      <span>IMEI:</span>
      <span>{{ previouslyValidatedImei() }}</span>
    </div>
    <div class="detail-row">
      <span>Lagring:</span>
      @if (selectedStorageCapacity(); as capacity) {
        <span>{{ capacity.size }}&nbsp;{{ capacity.unit }}</span>
      }
    </div>
  </span>
</div>
